module.exports = __webpack_public_path__ + "static/media/loading_animation.abb380b1.gif";